<section class="modal">
  <div class="modal__header-wrapper">
    <h3 class="modal__header">
      {{ title() }}
    </h3>
    <div class="modal__cross-wrapper" role="button" tabindex="0" (click)="close()">
      <app-icon class="modal__cross-icon" [icon]="IconName.ACTIVE_SESSIONS_CROSS" />
    </div>
  </div>

  <ng-content />
</section>
